import React from "react";

interface FooterLinkProps {
    name: string;
    url: string;
    external: boolean;
    className?: string;
}

/**
 * Reusable footer link component
 */
const FooterLink = ({ name, url, external, className = "" }: FooterLinkProps) => {
    return (
        <a
            className={`link link-hover font-semibold text-sm ${className}`}
            href={url}
            target={external ? "_blank" : undefined}
            rel={external ? "noopener noreferrer" : undefined}
        >
            {name}
        </a>
    );
};

export default FooterLink;
